// assets/lookbook-hotspots.js
(function () {
  const money = (cents) => {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const fmt =
          (window.theme && window.theme.moneyFormat) ||
          window.Shopify.money_format ||
          '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (_) {}
    const v = (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
    return `R$ ${v}`;
  };

  const escapeHtml = (s) =>
    String(s ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  // Normaliza "Cor / color" como seu snippet faz (bem próximo)
  const normalizeHandle = (raw) => {
    const s = String(raw ?? '').trim().toLowerCase();
    return s
      .replace(/[áàãâä]/g, 'a')
      .replace(/[éèêë]/g, 'e')
      .replace(/[íìîï]/g, 'i')
      .replace(/[óòõôö]/g, 'o')
      .replace(/[úùûü]/g, 'u')
      .replace(/ç/g, 'c')
      .replace(/[ _/]+/g, '-')
      .replace(/-+/g, '-');
  };

  const productCache = new Map();

  async function fetchProduct(handle) {
    if (!handle) throw new Error('Missing handle');
    if (productCache.has(handle)) return productCache.get(handle);

    const root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    const url = `${root}products/${handle}.js`;

    const p = fetch(url, { credentials: 'same-origin' })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => {
        productCache.set(handle, data);
        return data;
      });

    productCache.set(handle, p);
    return p;
  }

function getColorOptionIndex(product) {
  // 1) tenta achar por nome (como você já tinha)
  const opts = Array.isArray(product.options) ? product.options : [];
  for (let i = 0; i < opts.length; i++) {
    const n = String(opts[i] ?? '').toLowerCase().trim();
    if (n.includes('cor') || n.includes('color') || n.includes('colour')) return i;
  }

  // 2) fallback: assume option1 como cor se houver 2+ opções
  if (opts.length >= 2) return 0;

  // 3) se só existe 1 opção, ainda pode ser cor
  if (opts.length === 1) return 0;

  return -1;
}


  // ✅ Shopify product.js geralmente usa option1/option2/option3 (não v.options[])
  function getVariantOptionByIndex(variant, index) {
    const o = [variant?.option1, variant?.option2, variant?.option3];
    if (o[index] != null) return o[index];

    // fallback: algumas implementações trazem variant.options[]
    if (Array.isArray(variant?.options)) return variant.options[index];

    return null;
  }

  function getVariantImageSrc(variant) {
    // Shopify product.js costuma ter variant.featured_image.src (ou null)
    const fi = variant && variant.featured_image;
    if (fi && typeof fi === 'object' && fi.src) return fi.src;

    // fallback: pode vir como string em alguns casos
    if (variant && typeof variant.featured_image === 'string') return variant.featured_image;

    return '';
  }

  function pickVariantForColor(product, colorValue) {
    const colorIndex = getColorOptionIndex(product);
    const variants = Array.isArray(product.variants) ? product.variants : [];
    if (colorIndex < 0) return null;

    // prioriza disponível; senão pega a primeira da cor
    let firstMatch = null;

    for (const v of variants) {
      const opt = getVariantOptionByIndex(v, colorIndex);
      if (String(opt ?? '') !== String(colorValue ?? '')) continue;

      if (!firstMatch) firstMatch = v;
      if (v.available) return v;
    }

    return firstMatch;
  }

  function collectColors(product) {
    const colorIndex = getColorOptionIndex(product);
    if (colorIndex < 0) return [];

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const map = new Map();

    for (const v of variants) {
      const val = getVariantOptionByIndex(v, colorIndex);
      if (!val) continue;

      const key = String(val);

      if (!map.has(key)) {
        map.set(key, {
          value: key,
          available: Boolean(v.available),
          variantId: v.id
        });
      } else {
        if (v.available) map.get(key).available = true;
      }
    }

    return Array.from(map.values());
  }

  function readSwatchMapFromSection(sectionEl) {
    const el = sectionEl.querySelector('[data-color-swatch-map]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}') || {};
    } catch (_) {
      return {};
    }
  }

  function buildSwatchesHtml(colors, selectedValue, swatchMap, groupName) {
    if (!colors.length) return '';

    const items = colors
      .map((c) => {
        const h = normalizeHandle(c.value);
        const entry = swatchMap[h] || {};
        const hex = entry.hex || '';
        const img = entry.img || '';
        const soldOut = !c.available;

        return `
          <label class="lb-swatch${soldOut ? ' lb-swatch--sold-out' : ''}" title="${escapeHtml(c.value)}">
            <input
              type="radio"
              class="lb-swatch__input"
              name="${escapeHtml(groupName)}"
              value="${escapeHtml(c.value)}"
              ${String(c.value) === String(selectedValue) ? 'checked' : ''}
              ${soldOut ? 'disabled' : ''}
              data-color="${escapeHtml(c.value)}"
            >
            <span
              class="lb-swatch__dot${img ? ' lb-swatch__dot--image' : ''}"
              style="
                ${img ? `--swatch-img: url(${escapeHtml(img)});` : ''}
                ${hex ? `--swatch: ${escapeHtml(hex)};` : ''}
              "
              aria-hidden="true"
            ></span>
          </label>
        `;
      })
      .join('');

    return `
      <div class="lbmodalcard__swatches" aria-label="Cores">
        ${items}
      </div>
    `;
  }

  function renderModalContent(product, sectionEl) {
    const title = escapeHtml(product.title);
    const vendor = product.vendor ? escapeHtml(product.vendor) : '';
    const handle = escapeHtml(product.handle);

    const colorIndex = getColorOptionIndex(product);
    const colors = collectColors(product);

    const firstVariant =
      Array.isArray(product.variants) && product.variants[0] ? product.variants[0] : null;

    // ✅ Pega cor inicial pela option1/2/3 (fallback para colors[0])
    const initialColor =
      colorIndex >= 0 && firstVariant
        ? (getVariantOptionByIndex(firstVariant, colorIndex) || (colors[0]?.value || ''))
        : (colors[0]?.value || '');

    const initialVariant = pickVariantForColor(product, initialColor) || firstVariant;
    const initialVariantId = initialVariant ? initialVariant.id : '';
    const url = initialVariantId ? `/products/${handle}?variant=${initialVariantId}` : `/products/${handle}`;

    // imagem inicial
    const imgFromVariant = initialVariant ? getVariantImageSrc(initialVariant) : '';
    const imgFallback = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
    const imgSrc = imgFromVariant || imgFallback || '';
    const imgTag = imgSrc ? `<img src="${escapeHtml(imgSrc)}" alt="${title}" loading="lazy" data-lb-modal-img>` : '';

    const price = money(product.price);
    const compare =
      product.compare_at_price && product.compare_at_price > product.price
        ? money(product.compare_at_price)
        : '';

    const swatchMap = readSwatchMapFromSection(sectionEl);
    const swatches =
      colorIndex >= 0 && colors.length ? buildSwatchesHtml(colors, initialColor, swatchMap, `lb_color_${handle}`) : '';

    return `
      <div class="lbmodalcard" data-lbmodalcard data-handle="${handle}">
        <div class="lbmodalcard__img">
          ${imgTag}
        </div>

        <div class="lbmodalcard__body" data-lb-modal-body>
          ${vendor ? `<div class="lbmodalcard__vendor">${vendor}</div>` : ''}
          <a class="lbmodalcard__title" href="${url}" data-lb-modal-link data-origem-nav="navegacao__home__lookbook__titulo">${title}</a>

          ${swatches}

          <div class="lbmodalcard__price">
            ${compare ? `<span class="lbmodalcard__compare">${compare}</span>` : ''}
            <span class="lbmodalcard__main">${price}</span>
          </div>

          <div class="lbmodalcard__actions">
            <a class="lbmodalcard__btn" href="${url}" data-lb-modal-link data-origem-nav="navegacao__home__lookbook__botao">Ver produto</a>
          </div>
        </div>
      </div>
    `;
  }

  function bindModalInteractions(modalContentEl, product) {
    const card = modalContentEl.querySelector('[data-lbmodalcard]');
    if (!card) return;

    const imgEl = modalContentEl.querySelector('[data-lb-modal-img]');
    const linkEls = modalContentEl.querySelectorAll('[data-lb-modal-link]');
    const colorIndex = getColorOptionIndex(product);

    if (colorIndex < 0) return;

    const onColorChange = (colorValue) => {
      const variant = pickVariantForColor(product, colorValue);
      if (!variant) return;

      const handle = product.handle;
      const nextUrl = `/products/${handle}?variant=${variant.id}`;
      linkEls.forEach((a) => a.setAttribute('href', nextUrl));

      // troca imagem com prioridade para featured da variante
      const nextImg = getVariantImageSrc(variant);
      if (imgEl && nextImg) {
        imgEl.setAttribute('src', nextImg);
      }
    };

    // change handler (delegação)
    modalContentEl.addEventListener('change', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      if (!t.classList.contains('lb-swatch__input')) return;
      onColorChange(t.value);
    });
  }

  function initSection(sectionEl) {
    const sliderEl = sectionEl.querySelector('[data-lb-slider]');
    const prevBtn = sectionEl.querySelector('[data-lb-prev]');
    const nextBtn = sectionEl.querySelector('[data-lb-next]');
    const pagEl = sectionEl.querySelector('[data-lb-pagination]');

    const modal = sectionEl.querySelector('[data-lb-modal]');
    const modalContent = sectionEl.querySelector('[data-lb-modal-content]');
    const closeEls = sectionEl.querySelectorAll('[data-lb-close]');

    const openModal = () => {
      if (!modal) return;
      modal.hidden = false;
      document.documentElement.classList.add('lbmodal-lock');
      document.body.classList.add('lbmodal-lock');
    };

    const closeModal = () => {
      if (!modal) return;
      modal.hidden = true;
      if (modalContent) modalContent.innerHTML = '<div class="lbmodal__loading">Carregando…</div>';
      document.documentElement.classList.remove('lbmodal-lock');
      document.body.classList.remove('lbmodal-lock');
    };

    closeEls.forEach((el) => el.addEventListener('click', closeModal));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    sectionEl.querySelectorAll('[data-lb-hotspot]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const handle = btn.getAttribute('data-handle');
        if (!handle || !modalContent) return;

        openModal();
        modalContent.innerHTML = '<div class="lbmodal__loading">Carregando…</div>';

        try {
          const product = await fetchProduct(handle);
          modalContent.innerHTML = renderModalContent(product, sectionEl);
          bindModalInteractions(modalContent, product);
        } catch (err) {
          modalContent.innerHTML = `<div class="lbmodal__loading">Não foi possível carregar o produto.</div>`;
          console.warn('[Lookbook Hotspots] product fetch error:', err);
        }
      });
    });

    if (window.Swiper && sliderEl) {
      new window.Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        watchOverflow: true,
        navigation: prevBtn && nextBtn ? { prevEl: prevBtn, nextEl: nextBtn } : undefined,
        pagination: pagEl ? { el: pagEl, clickable: true } : undefined
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-lb]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
